import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
import { Role } from "./_helper";

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Camp",
    component: lazyLoad("Camp"),
    meta: { authorize: [] },
  },
  {
    path: "/prep",
    name: "Test Prep",
    component: lazyLoad("Prep"),
    meta: { authorize: [] },
  },

  // {
  //   path: "/prepv",
  //   name: "Test PrepV",
  //   component: lazyLoad("PrepV"),
  //   meta: { authorize: [] },
  // },

  // {
  //   path: "/st",
  //   name: "Select Test",
  //   component: lazyLoad("SelectTest"),
  //   meta: { authorize: [] },
  // },

  // {
  //   path: "/cr",
  //   name: "Find a class",
  //   component: lazyLoadComponent("course/CourseRegister"),
  //   meta: { authorize: [] },
  // },

  {
    path: "/camp",
    name: "Camp",
    component: lazyLoad("Camp"),
    meta: { authorize: [] },
  },
  {
    path: "/shop",
    name: "Shop",
    component: lazyLoad("Shop"),
    meta: { authorize: [] },
  },
  {
    path: "/course/:id",
    name: "Course",
    component: lazyLoad("Course"),
    meta: { authorize: [] },
  },
  {
    path: "/cart",
    name: "Shopping Cart",
    component: lazyLoad("ShoppingCart"),
    meta: { authorize: [] },
  },
  {
    path: "/about",
    name: "About",
    component: lazyLoad("About"),
    meta: { authorize: [] },
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: lazyLoad("Checkout"),
    meta: { authorize: [] },
  },
  {
    path: "/order/confirmation",
    name: "OrderConfirmation",
    component: lazyLoad("OrderConfirmation"),
    meta: { authorize: [] },
  },
  {
    path: "/login",
    name: "Login",
    component: lazyLoadComponent("auth/Login"),
    meta: { authorize: [] },
  },
  {
    path: "/register",
    name: "Register",
    component: lazyLoadComponent("auth/Register"),
    meta: { authorize: [] },
  },
  {
    path: "/secure/reset/password",
    name: "ResetPassword",
    component: lazyLoad("secure/ResetPassword"),
    meta: { authorize: [Role.User] },
  },
  {
    path: "/secure/edit/course",
    name: "EditCourse",
    component: lazyLoad("secure/EditCourse"),
    meta: { authorize: [Role.Admin] },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(
      (record) => record.path.startsWith("/secure/") || record.meta.requiresAuth
    )
  ) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
